import { aiAssistantWindow, LoginView } from "../interfaces";
import {Inject, Injectable} from "@angular/core";
import {WINDOW} from "@tylertech/shared-module";
import { CxService } from "./cx.service";
import { SystemInfoService } from "./systemInfo.service";

@Injectable()
export class aiAssistantService
{
    initialized = false;
    agentElement: HTMLSpanElement;
    overrideAgent: string;

    constructor(
        @Inject(WINDOW) private readonly window: aiAssistantWindow,
        private readonly $systemInfoService: SystemInfoService,
        private readonly $cxService: CxService
    ) { }

    //TODO: remove this when the backend builds up how it wants to determine EnableAIAgent
    temporaryTenantChecking(principle: LoginView): boolean
    {
        if (window.location.href.indexOf("escalation-chat") > -1)
            return;
        if (principle.Tenant === "financialsliveqa2")
        {
            // New agents won't work with the agent prefix, old agents require it
            this.overrideAgent = "b5cf73e4-802f-4423-b449-77382460dc21";
            this.$cxService.initialize();
            return true;
        }
        if (principle.Tenant === "CloudnineQA")
        {
            // New agents won't work with the agent prefix, old agents require it
            this.overrideAgent = "42aea2e2-0799-43eb-8a87-dfc51869edb4";
            this.$cxService.initialize();
            return true;
        }
        if (principle.Tenant === "aws_foundryea")
        {
            this.overrideAgent = "agent-61bae3d3-e042-4a59-bf40-92e99607a31a";
            return true;
        }
        else if (principle.Tenant === "ferristxtest1")
        {
            this.overrideAgent = "agent-af636a1b-8d03-46d3-899b-47877793346b";
            return true;
        }
        return principle?.Settings?.EnableAIAgent;
    }

    initializeScript(principle: LoginView): void
    {
        if (!this.temporaryTenantChecking(principle))
            return;
        if (this.initialized)
            return;

        let src = "";
        const staging = principle.Settings["staging"] as boolean;
        if (staging)
        {
            this.setStagingVariables();
            src = "https://staging-ai-foundry.socrata-qa.com/api/embed/embed.js";
        }
        else
        {
            this.setVariables(this.$systemInfoService.systemInfo.Product);
            src = "https://foundry.tylertechai.com/api/embed/embed.js";
        }

        this.agentElement = document.createElement("span");
        this.agentElement.id = "ai-assistant";
        const scriptElement = document.createElement("script");
        scriptElement.type = "text/javascript";
        scriptElement.defer = true;
        scriptElement.src = src;
        scriptElement.setAttribute("data-embed-script", "");
        this.agentElement.appendChild(scriptElement);
        const appOutletElement = document.querySelector("app-outlet");
        appOutletElement.parentNode.append(this.agentElement);

        this.initialized = true;
    }

    remove(): void
    {
        if (this.agentElement)
        {
            this.agentElement.remove();
            this.agentElement = undefined;
        }
        const button = document.getElementById("ai-foundry-start");
        if (button)
            button.remove();
        this.initialized = false;
    }

    private setVariables(product: string): void
    {
        this.window.tylerAIConfig = {
            baseUrl: "https://foundry.tylertechai.com",
            agentId: this.overrideAgent ? this.overrideAgent : this.AgentIdsBasedOnProduct[product],
            chatViewType: 'modal'
        };
    }

    private setStagingVariables(): void
    {
        this.window.tylerAIConfig = {
            baseUrl: "https://staging-ai-foundry.socrata-qa.com",
            agentId: "agent-f16e38d9-952f-4f34-af7c-285879f5bcd1",
            chatViewType: 'modal'
        };
    }

    private readonly AgentIdsBasedOnProduct: Record<string, string> = {
        "Incode10": "agent-5bf18a93-52c2-4b2b-8afc-0cc70b2b5be6",
        "Incode9": "agent-2a47b605-af66-44b9-98ef-befa42cdcd93",
        "Infinite Visions": "agent-757eb147-192d-4fef-ae86-8f5bbb47771b"
    };


}
